export const baseData = {
  title: "PRODUCT COLOUR"
}